import { gql } from '@apollo/client';

export const ALL_INTERVENTION_CLASSES = gql`
  query AllInterventionClasses {
    interventionClasses: getInterventionClasses {
      id
      name
    }
  }
`;
